const items = [
    "Residential",
    "Commercial",
    "Modular Kitchens",
    "Living Rooms",
    "Bedrooms",
    "Luxury Villas",
    "Office Interiors",
    "Bathroom Design",
    "Full Home Renovation",
];

export default function Marquee() {
    const loop = [...items, ...items];
    return (
        <section
            data-testid="marquee-strip"
            aria-hidden="true"
            className="bg-[#111111] border-y border-[#262626] py-7 overflow-hidden"
        >
            <div className="marquee-track">
                {loop.map((it, i) => (
                    <div key={i} className="flex items-center px-8 shrink-0">
                        <span className="font-display italic text-2xl md:text-3xl text-cream">
                            {it}
                        </span>
                        <span className="text-gold mx-8 text-2xl">·</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
